import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import { Button, ButtonGroup, Typography, Grid } from "@material-ui/core";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

export default function Ranking({
  question,
  questions,
  setQuestions,
  index,
  disabled,
}) {
  const npsValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const npsButtonStyle = () => {
    if (question.value >= 0 && question.value <= 6) {
      return {
        background: "#e48782",
        color: "#d02f27",
      };
    } else if (question.value >= 7 && question.value <= 8) {
      return {
        background: "#f9dba1",
        color: "#ffa900",
      };
    } else {
      return {
        background: "#ccdaf6",
        color: "#0249d0",
      };
    }
  };

  const npsButtonInitialStyle = (value) => {
    if (value >= 0 && value <= 6) {
      return {
        color: "#d02f27",
      };
    } else if (value >= 7 && value <= 8) {
      return {
        color: "#ffa900",
      };
    } else {
      return {
        color: "#0249d0",
      };
    }
  };

  const handleClick = (value) => {
    const clonedQuestions = [...questions];
    clonedQuestions[index].value = value;
    setQuestions(clonedQuestions);
  };

  const useStyles = makeStyles({
    nps: {
      fontWeight: 700,
      color: npsButtonStyle().color,
      background: npsButtonStyle().background,
      "&:hover": {
        background: npsButtonStyle().background,
      },
    },
    container: {
      marginBottom: 8,
    },
  });

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <ArrowBackIcon
            style={{ fontSize: 14, marginRight: 4 }}
            color="disabled"
          />
          <Typography variant="caption" color="textSecondary">
            Nem um pouco satisfeito
          </Typography>
        </Grid>

        <Grid item>
          <Typography variant="caption" color="textSecondary">
            Satisfeito
          </Typography>
          <ArrowForwardIcon
            style={{ fontSize: 14, marginLeft: 4 }}
            color="disabled"
          />
        </Grid>
      </Grid>

      <ButtonGroup variant="outlined" fullWidth size="large">
        {npsValues.map((item) => (
          <Button
            id={item}
            key={item}
            value={question.value}
            className={item === question.value && classes.nps}
            onClick={() => handleClick(item)}
            disabled={disabled}
            style={{ fontWeight: "bold", ...npsButtonInitialStyle(item) }}
          >
            {item}
          </Button>
        ))}
      </ButtonGroup>
    </div>
  );
}
